.trigger {
  display: var(--haus-selectCountry__trigger__display, flex);
  align-items: var(--haus-selectCountry__trigger__align-items, center);
  justify-content: var(--haus-selectCountry__trigger__justify-content, space-between);
  gap: var(--haus-selectCountry__trigger__gap, 8px);
  cursor: var(--haus-selectCountry__trigger__cursor, pointer);
  width: var(--haus-selectCountry__trigger__width, 100%);
  text-align: var(--haus-selectCountry__trigger__text-align, left);
  min-height: var(--haus-selectCountry__trigger__min-height, 44px);

  &:focus-visible {
    outline: var(
      --haus-selectCountry__trigger__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-selectCountry__trigger__focus-visible__outline-offset, 2px);
  }
}

.value {
  flex: var(--haus-selectCountry__value__flex, 1 1 auto);
  overflow: var(--haus-selectCountry__value__overflow, hidden);
  text-overflow: var(--haus-selectCountry__value__text-overflow, ellipsis);
  white-space: var(--haus-selectCountry__value__white-space, nowrap);

  &[data-placeholder] {
    color: var(
      --haus-selectCountry__value__placeholder-color,
      var(--haus-input-placeholder-color, #999)
    );
  }
}

.dropdownContent {
  position: var(--haus-selectCountry__dropdownContent__position, relative);
  background: var(--haus-selectCountry__dropdownContent__background, #fff) !important;
  border: var(--haus-selectCountry__dropdownContent__border, 1px solid #e5e7eb) !important;
  border-radius: var(--haus-selectCountry__dropdownContent__border-radius, 8px);
  padding: var(--haus-selectCountry__dropdownContent__padding, 0);
  width: var(--haus-selectCountry__dropdownContent__width, var(--radix-select-trigger-width));
  min-width: var(
    --haus-selectCountry__dropdownContent__min-width,
    var(--radix-select-trigger-width)
  );
  z-index: var(--haus-selectCountry__dropdownContent__z-index, 99999) !important;
  box-shadow:
    var(
      --haus-selectCountry__dropdownContent__box-shadow-layer-1,
      0 4px 6px -1px rgba(0, 0, 0, 0.1)
    ),
    var(
      --haus-selectCountry__dropdownContent__box-shadow-layer-2,
      0 2px 4px -1px rgba(0, 0, 0, 0.06)
    );
}

.selectViewport {
  border-radius: var(--haus-selectCountry__selectViewport__border-radius, 8px);
  max-height: var(--haus-selectCountry__selectViewport__max-height, 320px);
  overflow: var(--haus-selectCountry__selectViewport__overflow, auto);
  box-sizing: var(--haus-selectCountry__selectViewport__box-sizing, border-box);
  display: var(--haus-selectCountry__selectViewport__display, grid);
  gap: var(--haus-selectCountry__selectViewport__gap, 10px);
  padding: var(--haus-selectCountry__selectViewport__padding, 8px);
}

.selectItem {
  display: var(--haus-selectCountry__selectItem__display, flex);
  align-items: var(--haus-selectCountry__selectItem__align-items, center);
  gap: var(--haus-selectCountry__selectItem__gap, 10px);
  padding: var(--haus-selectCountry__selectItem__padding, 8px);
  border-radius: var(--haus-selectCountry__selectItem__border-radius, 8px);
  font-size: var(--haus-selectCountry__selectItem__font-size, 14px);
  line-height: var(--haus-selectCountry__selectItem__line-height, 1.2);
  color: var(--haus-selectCountry__selectItem__color, var(--haus-color-body));
  font-family: var(
    --haus-selectCountry__selectItem__font-family,
    var(--haus-typography-body-font-family)
  );
  cursor: var(--haus-selectCountry__selectItem__cursor, pointer);
  outline: var(--haus-selectCountry__selectItem__outline, 2px solid transparent);
  user-select: var(--haus-selectCountry__selectItem__user-select, none);

  &:hover {
    background-color: var(--haus-selectCountry__selectItem__hover__background-color, #f6f6f6);
  }

  &[data-highlighted] {
    background-color: var(--haus-selectCountry__selectItem__highlighted__background-color, #f6f6f6);
  }

  &:focus-visible {
    outline: var(
      --haus-selectCountry__selectItem__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-selectCountry__selectItem__focus-visible__outline-offset, 2px);
  }
}

.checkIconSpacer {
  width: var(--haus-selectCountry__checkIconSpacer__width, 16px);
  height: var(--haus-selectCountry__checkIconSpacer__height, 16px);
  flex-shrink: var(--haus-selectCountry__checkIconSpacer__flex-shrink, 0);
  display: var(--haus-selectCountry__checkIconSpacer__display, flex);
  align-items: var(--haus-selectCountry__checkIconSpacer__align-items, center);
  justify-content: var(--haus-selectCountry__checkIconSpacer__justify-content, center);
}

.itemIndicator {
  display: var(--haus-selectCountry__itemIndicator__display, flex);
  align-items: var(--haus-selectCountry__itemIndicator__align-items, center);
  justify-content: var(--haus-selectCountry__itemIndicator__justify-content, center);
  color: var(--haus-selectCountry__itemIndicator__color, var(--haus-color-body));
  flex-shrink: var(--haus-selectCountry__itemIndicator__flex-shrink, 0);
  width: var(--haus-selectCountry__itemIndicator__width, 16px);
  height: var(--haus-selectCountry__itemIndicator__height, 16px);
}
